export { allLocations } from './locations.queries';

export { currentUser, settings } from './user.queries';

export { restaurant } from './restaurant.queries';
